import { Route, Navigate } from 'react-router-dom';

export function RedirectRoutes() {
  return (
    <>
      {/* Legacy URL redirects */}
      <Route path="/login" element={<Navigate to="/auth" replace />} />
      <Route path="/register" element={<Navigate to="/auth/individual" replace />} />
      <Route path="/signup" element={<Navigate to="/auth/individual" replace />} />
      <Route path="/signin" element={<Navigate to="/auth" replace />} />
      
      {/* Old formation URLs */}
      <Route path="/training/:id" element={<Navigate to="/formation/:id" replace />} />
      <Route path="/trainings" element={<Navigate to="/formations" replace />} />
      
      {/* Old dashboard URLs */}
      <Route path="/account" element={<Navigate to="/profile" replace />} />
      <Route path="/settings" element={<Navigate to="/profile" replace />} />
      
      {/* Old intra page */}
      <Route path="/intra" element={<Navigate to="/formations" replace />} />
      
      {/* Old inscription URLs */}
      <Route path="/inscription-tunnel/:courseId" element={<Navigate to="/inscription/:courseId" replace />} />
      
      {/* Old legal URLs */}
      <Route path="/legal" element={<Navigate to="/mentions-legales" replace />} />
      <Route path="/privacy" element={<Navigate to="/politique-confidentialite" replace />} />
      <Route path="/terms" element={<Navigate to="/cgv" replace />} />
      
      {/* GSC indexation fixes */}
      <Route path="/conditions-generales-vente" element={<Navigate to="/cgv" replace />} />
      <Route path="/conditions-generales-utilisation" element={<Navigate to="/cgu" replace />} />
      <Route path="/connexion-apprenant" element={<Navigate to="/auth" replace />} />
      <Route path="/inscription" element={<Navigate to="/formations" replace />} />
      
      {/* Old blog slug redirects */}
      <Route path="/blog/automatiser-gestion-tournees" element={<Navigate to="/blog/automatiser-gestion-tournees-airtable-make" replace />} />
      <Route path="/blog/airtable-vs-excel" element={<Navigate to="/blog/airtable-vs-excel-operations" replace />} />
      <Route path="/blog/make-guide-debutant-automatisation" element={<Navigate to="/blog/make-guide-debutant-automatisations" replace />} />
      <Route path="/blog/5-outils-no-code-pme-transport" element={<Navigate to="/blog/5-outils-nocode-pme-transport-2025" replace />} />
    </>
  );
}
